import React, { useState, useEffect } from 'react';
import { ArrowLeft } from 'lucide-react';
import toast, { Toaster } from 'react-hot-toast';
import styles from '../Register/Register.module.css';
import { useAuth } from '../Context/Auth';
import { Link, useNavigate } from 'react-router-dom';
import carLogo from '../Image/logocar-CN7UAsq-.png';

const Register = () => {
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const { registerUser, loading } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if(password !== confirmPassword){
      toast.error("Passwords do not match 😢");
      return;
    }

    const registerPromise = new Promise(async (resolve, reject) => {
      try {
        const result = await registerUser({ fullName, email, phoneNumber, password, confirmPassword });
        if (result && result.Success) {
          localStorage.setItem('userEmail', email);
          localStorage.setItem('userToken', result.Data?.AccessToken || '');
          resolve(result);
        } else {
          reject(new Error('Failed to register 😢'));
        }
      } catch {
        reject(new Error('Failed to register 😢'));
      }
    });

    toast.promise(
      registerPromise,
      {
        loading: 'Registering...',
        success: 'Account created successfully! 🎉',
        error: (err) => err.message,
      }
    );

    try {
      await registerPromise;
      setTimeout(() => {
        navigate('/login');
      }, 1000);
    } catch {
      // الخطأ تم عرضه بواسطة toast
    }
  };

  useEffect(() => {
    document.body.classList.add('login-page');
    return () => {
      document.body.classList.remove('login-page');
    };
  }, []);

  return (
    <div className={styles.loginContainer}>
      <Toaster position="top-center" reverseOrder={false} />

      <div className={styles.loginBox}>
        <div className={styles.logoContainer}>
          <img src={carLogo} alt="KARZONE Logo" className={styles.logo} />
          <h1 className={styles.brandName}>KARZONE</h1>
          <h2 className={styles.tagline}>PremiumDrive</h2>
          <p className={styles.subTagline}>LUXURY MOBILITY EXPERIENCE</p>
        </div>

        <form onSubmit={handleSubmit} style={{ width: '100%' }}>
          <div className={styles.formGroup}>
            <input
              type="text"
              className={styles.inputField}
              placeholder="Full Name"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              required
            />
          </div>

          <div className={styles.formGroup}>
            <input
              type="email"
              className={styles.inputField}
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className={styles.formGroup}>
            <input
              type="tel"
              className={styles.inputField}
              placeholder="Phone Number"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              required
            />
          </div>

          <div className={`${styles.formGroup} ${styles.passwordField}`}>
            <input
              type={showPassword ? 'text' : 'password'}
              className={styles.inputField}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <span
              className={styles.eyeIcon}
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? '👁️' : '👁️‍🗨️'}
            </span>
          </div>

          <div className={`${styles.formGroup} ${styles.passwordField}`}>
            <input
              type={showPassword ? 'text' : 'password'}
              className={styles.inputField}
              placeholder="Confirm Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>

          <button
            type="submit"
            className={styles.loginButton}
            disabled={loading}
          >
            {loading ? 'REGISTERING...' : 'CREATE ACCOUNT'}
          </button>
        </form>

        <p className={styles.accountText}>Already have an account?</p>
        <Link to="/login" className={styles.createAccountLink}>
          LOGIN
        </Link>
      </div>
    </div>
  );
};

export default Register;
